import { FontFamily, Fonts, FontStyleSheet } from '@gamiphy/bl/font';
import { ThemeDto } from '@coretava/api/core-service';

export const getThemeFonts = (theme: ThemeDto): Fonts[] => {
  if (theme) {
    if (theme.supportedFonts?.length) {
      return theme.supportedFonts as Fonts[];
    }
    if (theme.font) {
      return [theme.font as Fonts];
    }
  }
  return [Fonts.Poppins];
};

export const getThemeFontStyleSheets = (theme: ThemeDto): string[] => getThemeFonts(theme)
  .map((font) => FontStyleSheet[font]);

export const getThemeFontFamilies = (theme: ThemeDto): FontFamily[] => getThemeFonts(theme)
  .map((font) => FontFamily[font]);
